import { render, staticRenderFns } from "./igt-sidebar-layout.vue?vue&type=template&id=7c34c0a1&scoped=true&"
import script from "./igt-sidebar-layout.vue?vue&type=script&lang=js&"
export * from "./igt-sidebar-layout.vue?vue&type=script&lang=js&"
import style0 from "./igt-sidebar-layout.vue?vue&type=style&index=0&id=7c34c0a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c34c0a1",
  null
  
)

export default component.exports